import React, { useState } from "react";
import "./InputCandidateInfo.css";

const NotesInput = ({
  icon,
  inputRef,
  setField,
  field,
  placeHolder,
  className = "",
  style = {},
  required = false,
  disabled = false,
  height,
  width = "100%",
  onClick = () => {},
  onFocus = () => {},
  onBlur = () => {},
  onKeyDown = () => {},
  hidden = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  if (hidden) return "";

  const showFloatingLabel = isFocused || field;
  return (
    <div 
      className={`input-shell ${showFloatingLabel ? 'input-shell-focused' : ''}`} 
      style={{ width, height, ...style }}>
        {showFloatingLabel && (
          <div className={`floating-label ${showFloatingLabel ? 'floating-label-focused' : ''}`}>
            {placeHolder}
          </div>
        )}
      <div className="input-design">
        {!showFloatingLabel && (
          <>
            <img className="input-icon" src={icon} alt="icon" style={{ position: "relative", top: "-1px" }} />
            <div className="input-placeholder">{placeHolder}</div>
          </>
        )}
      </div>

      <textarea
        ref={inputRef}
        disabled={disabled}
        required={required}
        onClick={onClick}
        onChange={(e) => setField(e)}
        value={field}
        onKeyDown={onKeyDown}
        onFocus={(e) => {
          setIsFocused(true);
          onFocus(e);
        }}
        onBlur={(e) => {
          setIsFocused(false);
          onBlur(e);
        }}
        rows="4"
        className={`form-control input-candidate-field ${className}`}
        style={{
          width: "100%",
          height: "100%",
          padding: "10px 12px",
          resize: "none",
        }}
      />
    </div>
  );
};

export default NotesInput;
